<div class="search-results-tab-container own-scroll">
  <nb-list
    *ngIf="firstCard.news.length > 0"
    nbInfiniteList
    [threshold]="200"
    (bottomThreshold)="loadNext(firstCard)"
    (scroll)="onScroll($event)"
    class="search-result-list"
  >
    <nb-list-item
      class="y"
      *ngFor="let result of firstCard.news; let i = index"
      (click)="navigateToSubscribers(result, data.type)"
    >
      <div>
        <nb-icon nbPrefix icon="car-outline" pack="eva"></nb-icon>
        <span class="label">{{ 'IDENTIFICATION.OWNER' | translate }}:</span>
        <span class="no-search-results">{{
          result.owner ? result.owner['lastName'] : ('GLOBAL_SEARCH.NO_RESULT' | translate)
        }}</span>
      </div>
      <div>
        <app-license-plate
          *ngIf="result && result.country && result.license"
          [country]="result.country"
          [licence]="result.license"
        ></app-license-plate>
      </div>
    </nb-list-item>
    <nb-list-item *ngFor="let _ of firstCard.placeholders">
      <p>Loading ...</p>
    </nb-list-item>
  </nb-list>
  <div *ngIf="data.results.length === 0" class="no-search-results">
    {{ 'GLOBAL_SEARCH.NO_SEARCH_RESULTS' | translate }}
  </div>
</div>
<div class="z" [class]="data.count > 5 ? 'showMoreIcon' : 'hideMoreIcon'">
  <nb-icon nbSuffix icon="{{ scrollIcon }}" pack="eva" class="icon-navigate"></nb-icon>
</div>
